export const videoList = [

    {
        id: 'v1',
        url: './videos/farm_video.mov',
        title: 'Old MacDonald Had A Farm | Nursery Rhymes | Super Simple Songs',
        subTitle: 'Image by macrovector/Freepik',
        videoTag: 'Music & Rhythm',
        recommended: true,
        liked: false,
    },
    {
        id: 'v2',
        url: './videos/alphabet.mov',
        title: "The Alphabet Is So Much Fun | Kids Songs",
        subTitle: 'Image by macrovector/Freepik',
        videoTag: 'Alphabet & Numbers',
        recommended: false,
        liked: true,
    },
    {
        id: 'v3',
        url: './videos/animal.mov',
        title: 'Animal sounds song | Nursery Rhymes',
        subTitle: 'Image by macrovector/Freepik',
        videoTag: 'Animal Names',
        recommended: true,
        liked: true,
    },
    {
        id: 'v4',
        url: './videos/science.mov',
        title: "Science Song for Kids with Lyrics",
        subTitle: 'Image by macrovector/Freepik',
        videoTag: 'Science Concepts',
        recommended: false,
        liked: false,
    },
    {
        id: 'v5',
        url: './videos/shape_video.mov',
        title: "What's Your Favorite Color? | Kids Songs | Super Simple Songs",
        subTitle: 'Image by macrovector/Freepik',
        videoTag: 'Shapes & Colors',
        recommended: true,
        liked: false,
    },
    {
        id: 'v6',
        url: './videos/pet.mov',
        title: "I have a pet | Animal song",
        subTitle: 'Image by macrovector/Freepik',
        videoTag: 'Music & Rhythm',
        recommended: false,
        liked: false,
    },
    
]